import Modal from "react-modal";
import PulseLoader from "react-spinners/PulseLoader";
import Button, {BtnColor} from "../../../components/Button/Button";
import {useDispatch, useSelector} from "react-redux";
import {REFUND_REASON_DUBLICATE, REFUND_REASON_FRAUDULENT, REFUND_REASON_CUSTOMER, REFUND_REASON_OTHER} from "../../../store/Orders/reducer";
import {
    onOrderUpdateRefundReason,
    onOrderUpdateRefundReasonAmount,
    onOrderUpdateRefundReasonText
} from "../../../store/Orders/actions";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";

const RefundModal = ({  order, onCancel, onRefund, loading = false,  }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch();

    useEffect(() => {
        if (order.total) {
            dispatch(onOrderUpdateRefundReasonAmount(order.total))
        }
    },[order])


    const onChangeRefundReason = (e) => dispatch(onOrderUpdateRefundReason(e.target.value))
    const onChangeRefundReasonText = (e) => dispatch(onOrderUpdateRefundReasonText(e.target.value))
    const onChangeRefundReasonAmount = (e) => dispatch(onOrderUpdateRefundReasonAmount(e.target.value))

    const refundReason = useSelector(({orders}) => orders.refundReason)
    const refundReasonText = useSelector(({orders}) => orders.refundReasonText)
    const refundReasonAmount = useSelector(({orders}) => orders.refundReasonAmount)
    const refundVisible = useSelector(({orders}) => orders.refundVisible)

    return (
        <Modal
            isOpen={refundVisible}
            onRequestClose={onCancel}
            closeTimeoutMS={200}
            shouldCloseOnOverlayClick={true}
            ariaHideApp={false}
            className="mt-20 mb-6 bg-white rounded-lg overflow-hidden shadow-xl transform transition-all xl:w-1/4 sm:w-1/2 mx-auto"
            style={{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(107, 114, 128, 0.75)'
                },
            }}
        >
            <div className="">
                <div className="px-6 py-4">
                    <div className="text-lg flex justify-between">
                        {t('Refund payment')}
                        <PulseLoader color="rgba(79, 70, 229, 1)" loading={loading}  size={7} />
                    </div>

                    <div className="mt-6">
                        <span className="font-bold text-sm">
                            {t('Refunds take 5-10 days to appear on a customer\'s statement.')}
                        </span>
                    </div>
                    <div className="mt-4">
                        <div className="bg-white">

                            <form className="w-full max-w-sm">
                                <div className="md:flex md:items-center mb-6">
                                    <div className="md:w-1/3">
                                        <label className="block text-gray-500 md:text-right mb-1 md:mb-0 pr-4">
                                            {t('Refund')}
                                        </label>
                                    </div>
                                    <div className="md:w-2/3">
                                        <input
                                            className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                                            id="inline-full-name"
                                            type="text"
                                            onChange={onChangeRefundReasonAmount}
                                            value={refundReasonAmount}
                                        />
                                    </div>
                                </div>
                                <div className="md:flex md:items-center mb-6">
                                    <div className="md:w-1/3">
                                        <label className="block text-gray-500 md:text-right mb-1 md:mb-0 pr-4">
                                            {t('Reason')}
                                        </label>
                                    </div>
                                    <div className="md:w-2/3">
                                        <select
                                            onChange={onChangeRefundReason}
                                            value={refundReason}
                                            className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                                            <option>Select a reason</option>
                                            <option value={REFUND_REASON_DUBLICATE}>{t('Dublicate')}</option>
                                            <option value={REFUND_REASON_FRAUDULENT}>{t('Fraudulent')}</option>
                                            <option value={REFUND_REASON_CUSTOMER}>{t('Requested by customer')}</option>
                                            <option value={REFUND_REASON_OTHER}>{t('Other')}</option>
                                        </select>
                                    </div>
                                </div>
                                {refundReason != '' ? (
                                    <div className="md:flex md:items-center mb-6">
                                        <div className="md:w-1/3">
                                        </div>
                                        <div className="md:w-2/3">
                                            <textarea name=""
                                                      onChange={onChangeRefundReasonText}
                                                      value={refundReasonText}
                                                      id=""
                                                      rows="2"
                                                      placeholder={t('Add more details about this refund.')}
                                                      className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
                                            />
                                        </div>
                                    </div>
                                ):null}

                            </form>


                        </div>
                    </div>
                </div>
                <div className="px-6 py-4 bg-gray-100 text-right">
                    <Button onClick={onCancel}>
                        {t('Cancel')}
                    </Button>
                    <Button color={BtnColor.indigo} className="ml-2" onClick={onRefund}>{t('Refund')}</Button>

                </div>
            </div>

        </Modal>
    )
}

export default RefundModal;
